<template>
  <div class="home">
    <banner />
    <section class="container">
      <div class="textEnergy">
        <p><img :src="$t('homepage.text_img_cn')" alt="" /></p>
        <h4>{{ $t('homepage.text0') }}</h4>
        <p class="art_item">
          {{ $t('homepage.text1') }}
        </p>
      </div>
      <powerList />
      <data_card />
      <!-- <p style="padding: 10px 0"><img src="@/assets/images/cc/test.gif" /></p> -->
      <section><powerText /></section>
      <data_card2 />
      <section class="carousel"><carousel_images /></section>
      <!-- <section class="carousel"><carousel /></section> -->
      <advantage />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import data_card from '@/components/data_card.vue';
import data_card2 from '@/components/data_card2.vue';

import powerText from '@/components/powerText.vue';

import banner from '@/components/banner.vue';
import powerList from '@/components/powerList.vue';
import carousel from '@/components/carousel.vue';
import carousel_images from '@/components/carousel_Images.vue';
import advantage from '@/components/advantage.vue';
export default {
  name: 'HomeView',
  components: {
    banner,
    powerList,
    carousel_images,
    carousel,
    advantage,
    powerText,
    data_card,
    data_card2,
  },
};
</script>
<style lang="scss" scoped>
.art_item {
  padding: 1rem 0;
  color: #908f8d;
}
.textEnergy {
  padding: 1.2rem 0;
}
h3 {
  font-size: 18px;
}
h3,
h4 {
  font-size: 18px;
}
.enerIcon {
  padding: 1rem 0;
}
.carousel {
  margin: 20px 0 0 0;
}
</style>
